import { getUploadFileUrl, uploadFile, getFileUploadUrl } from './services'

export const uploadReceipt = async (file: File) => {
  try {
    const response = await getUploadFileUrl(file.type)
    if (!response?.data?.url) {
      return { status: 'error', error: 'No upload URL returned' }
    }
    const uploadUrl = response.data.url
    const uploadResponse = await uploadFile(uploadUrl, file)
    if (uploadResponse.status !== 200) {
      return { status: 'error', error: 'Upload failed' }
    }
    const id = getId(uploadUrl)
    const receiptUrl = await getReceiptUrl(id)
    return { status: 'success', downloadUrl: receiptUrl.url }
  } catch (error) {
    return { status: 'error', error: error.message }
  }
}

const getId = (url: string) => {
  const parsedUrl = new URL(url)
  const pathSegments = parsedUrl.pathname.split('/')
  return pathSegments[pathSegments.length - 1]
}

const getReceiptUrl = async (id: string) => {
  try {
    const response = await getFileUploadUrl(id)
    if (!response?.data?.url) {
      return { status: 'error', error: 'No receipt URL returned' }
    }
    return { status: 'success', url: response.data.url }
  } catch (error) {
    return { status: 'error', error: error.message }
  }
}
